export default [
  {
    group: 'advertising',
    roles: [
      {
        value: 'media_buying',
        label: 'Media Buying',
        alt_label: 'Media Buyer/Planner',
        rank: 4,
      },
      { value: 'paid_media', label: 'Paid Media', rank: 2 },
      {
        value: 'planning',
        label: 'Planning',
        alt_label: 'Account Planner',
        rank: 3,
      },
      { value: 'programmatic', label: 'Programmatic / Ad Ops', rank: 6 },
      { value: 'digital_consultant', label: 'Digital Consultant', rank: 5 },
    ],
  },

  {
    group: 'creative',
    roles: [
      { value: 'copywriting', label: 'Copywriting' },
      { value: 'creative_development', label: 'Creative Development' },
      {
        value: 'creative_freelancer',
        label: 'Creative Freelancer',
        freelancer: true,
      },
      { value: 'creative_strategy', label: 'Creative Strategy' },
      { value: 'design', label: 'Design' },
    ],
  },

  {
    group: 'operations',
    roles: [
      { value: 'bids', label: 'Bids' },
      { value: 'finance', label: 'Finance' },
      { value: 'human_resources', label: 'Human Resources / Recruitment' },
      { value: 'office_management', label: 'Office Management' },
      { value: 'project_management', label: 'Project Management' },
      { value: 'resourcing', label: 'Resourcing' },
      { value: 'systems', label: 'Systems / IT' },
    ],
  },

  {
    group: 'research',
    roles: [{ value: 'research', label: 'Research' }],
  },

  {
    group: 'sales',
    roles: [
      { value: 'account_management', label: 'Account Management' },
      { value: 'business_development', label: 'Business Development' },
      { value: 'marketing', label: 'Marketing' },
    ],
  },

  {
    group: 'technology',
    roles: [
      { value: 'business_intelligence', label: 'Business Intelligence' },
      { value: 'consultancy', label: 'Consultancy' },
      { value: 'data_science', label: 'Data Science' },
      { value: 'quality_assurance', label: 'Quality Assurance / Testing' },
      { value: 'software_development', label: 'Software Development' },
      { value: 'support', label: 'Support' },
      { value: 'web_analysis', label: 'Web Analysis' },
    ],
  },
]
